import React, { Component } from "react";
//import {Link} from 'react-router-dom';

class OldHomePage extends Component {
  render() {
    return (
      <div>
        <div className="main_bg_container" />
        <div className="container-fluid container_blurb_main p-5">
          <div className="container p-5">
            <h1 className="main-title pt-5">
              <strong>
                <i className="fa fa-check-circle-o" /> Intuitive. Flexible.
                Fast.
              </strong>
            </h1>
            <p className="intro-blurb">
              “We, as a Microsoft Partner, worked with a group of Microsoft Most
              Valuable Professionals (MVPs) to create a state-of-the-art
              Point-of-Sales (POS) system for any businesses. This POS product
              is the only reliable solution in the market with 24/7 customer
              service which complies with government (Canada Revenue Agency)
              reporting, complies with Canadian Privacy Laws and Regulations,
              and it has full Data Backup and Restore to accelerate your
              transactions and order takings.” – Amir Ahani, TechPOS
            </p>
          </div>
        </div>
        <div className="container container-secondary main_summary p-5">
          <div className="row text-justify pb-5 mb-5 row-eq-height">
            <div className="col-md-4">
              <i
                className="fa fa-database fa-4x pb-3 text-center"
                aria-hidden="true"
              />
              <h2 className="pb-3 text-left">Free Data Import</h2>
              <p>
                No matter which POS system you are currently using, we offer
                FREE Data Import without any interruptions to your business.
                Either your current POS system supports exporting your existing
                data or our data entry experts have to manually enter them to
                our system. This process increases the productivity of your
                business by continuing your day-to-day sales instead of
                allocating your staff to reenter the existing data.
              </p>
            </div>
            <div className="col-md-4">
              <i className="fa fa-briefcase fa-4x pb-3" aria-hidden="true" />
              <h2 className="pb-3 text-left">On-Site Training</h2>
              <p>
                Our certified training specialists have the knowledge and
                insight it takes to ensure that your investment in the POS
                system is backed by superior product and usability training,
                equipping you the full power of the TechPOS system.
              </p>
            </div>
            <div className="col-md-4">
              <i className="fa fa-lock fa-4x pb-3" aria-hidden="true" />
              <h2 className="pb-3 text-left">Data Privacy Law & Security</h2>
              <p>
                Our Team ensure data privacy for all customers, patients and all
                records are kept confidential, protected by the Canadian Privacy
                Laws, Privacy Act, Personal Information Protection & Electronic
                Documents Act (PIPEDA). These standards are fully supported by
                Microsoft Azure in their local Canadian data centers.
              </p>
            </div>
          </div>
          <div className="row text-justify row-eq-height mt-3">
            <div className="col-md-4">
              <i className="fa fa-wrench fa-4x pb-3" aria-hidden="true" />
              <h2 className="pb-3 text-left">24/7 Customer Service</h2>
              <p>
                We work hard to provide assistance to our customers 24 hours a
                day, 7 days a week. Our dedicated team is here for you to
                troubleshoot any problems in person or remotely. With quick
                response times and friendly service, our customer care team is
                hard to beat.
              </p>
            </div>
            <div className="col-md-4">
              <i className="fa fa-money fa-4x pb-3" aria-hidden="true" />
              <h2 className="pb-3 text-left">Accounting</h2>
              <p>
                We provide a fully integrated accounting system including
                processing bi-weekly Payroll for your staff with WorkSafeBC, CRA
                reporting, and remittances (GST, PST).
              </p>
            </div>
            <div className="col-md-4">
              <i className="fa fa-archive fa-4x pb-3" aria-hidden="true" />
              <h2 className="pb-3 text-left">Smart Inventory</h2>
              <p>
                Our inventory system is designed based on the architecture of
                warehouse systems that are capable of processing millions of
                transactions in real-time with no problem.
              </p>
              <br />
              <p>
                It has four levels of transfers which manage the products from
                the time it has arrived to the store to the time that it is been
                processed and is gone out of the store. It forecasts when to
                order items that are out of stock or the items that are
                frequently ordered using advanced machine learning techniques.
              </p>
            </div>
          </div>
          <div className="row text-justify row-eq-height mt-3">
            <div className="col-md-4">
              <i className="fa fa-gavel fa-4x pb-3" aria-hidden="true" />
              <h2 className="pb-3 text-left">CRA & Gov't Compliance</h2>
              <p>
                TechPOS (POS for Dispensary) system is using a novel engine to
                cover the business rules that CRA has regulated and governed per
                each province. The system captures the sales taxes to facilitate
                the process of filing GST collection.
              </p>
              <br />
              <p>
                TechPOS system is pioneer in pursuing compliance procedures to
                ensure that recreational marijuana products can be tracked in
                the regulated market. This compliance is about tracking who has
                supplied the cannabis product to a particular store, which
                percentage was purchased by whom. In TechPOS, we call this
                compliance C-METRC (also referred to as METRC in some states in
                USA).
              </p>
            </div>
            <div className="col-md-4">
              <i className="fa fa-download fa-4x pb-3" aria-hidden="true" />
              <h2 className="pb-3 text-left">Data Recovery & Backup</h2>
              <p>
                It is crucial to back up your data regularly as this is the
                heart of your business. We offer regular data backups and
                restore to avoid any data loss in your business. To ensure that
                your data is stored in a safe location, look no further than our
                100% guaranteed secure and encrypted data using latest Microsoft
                technologies.
              </p>
            </div>
            <div className="col-md-4">
              <i className="fa fa-wifi fa-4x pb-3" aria-hidden="true" />
              <h2 className="pb-3 text-left">Tablet Friendly (Responsive)</h2>
              <p>
                TechPOS (POS for Dispensary) application is accessible from all
                portable devices such as Tablets offered by Apple, Android and
                Microsoft. Moreover, it is easy to configure. All the hardware
                devices can communicate wirelessly with no need of messy wires
                and cables to connect to your POS system.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OldHomePage;
